import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '../../base.component';
import { ClientService } from 'src/app/services/clients/client.service';
import { CampaignBuilderService } from 'src/app/services/segmentation/campaign-builder.service';

@Component({
  selector: 'app-add-campaign-events',
  templateUrl: './add-campaign-events.component.html'
})
export class AddCampaignEventsComponent extends BaseComponent implements OnInit {
  eventForm:FormGroup;
  headers='Add';
  getCompanyobj:any=[];
  submitted:boolean=false;
  eventId:any;
  companyID: any;
  eventData: any;
  constructor(
    private formBuilder : FormBuilder,
    private clientService: ClientService,
    private cbservice:CampaignBuilderService
  ) { 
    super();
   
  }

  ngOnInit(): void {
    this.activatedRoute.queryParams.subscribe((params)=>{
      if(params.id){
        this.eventId = params.id;
        this.companyID = params.companyID;
        console.log(params);
        this.headers='Edit';
      }
    })
    this.getCompany()
    this.eventForm = this.formBuilder.group({
      company:['',Validators.required],
      eventType:['',Validators.required],
      eventTitle:['',Validators.required]
    })
    if(this.headers=='Edit'){
      this.getCampaignEventById();
    }
  }
  get f(){ return this.eventForm.controls };
  getCompany() {
    let self = this;
    this.clientService.getBUCompanies().subscribe(data => {
      self.getCompanyobj = data.data;
      self.hydrateWorkingCompany(self);

    }, error => {
    });
  }

  getCampaignEventById(){
    this.cbservice.getCampaignEventById(this.companyID,this.eventId).subscribe({
      next:(res:any)=>{
        if(res.status){
          this.eventData = res.data.rows[0]; 
          this.eventForm.patchValue({
            company:this.companyID,
            eventType:this.eventData.type,
            eventTitle:this.eventData.title
          })
        }
      }
    })
  }
  onAdd(){
    if(this.eventForm.invalid){ console.log(this.eventForm.controls)};
    let payload = {
      type:this.eventForm.value.eventType,
      title:this.eventForm.value.eventTitle
    }
    this.ngxSpinnerService.show();
    this.cbservice.createCampaignEvent(this.eventForm.value.company,payload).subscribe({
      next:(res:any)=>{
        this.ngxSpinnerService.hide();
        this.toastrService.success('Campaign event created successfully');
        this.router.navigateByUrl('/corporate/campaign-event-list');
      },
      error:(error:any)=>{
        this.ngxSpinnerService.hide();
        this.toastrService.success('something went wrong')
      }
    })
  }
  onUpdate(){
    if(this.eventForm.invalid){ console.log(this.eventForm.controls)};
    let payload = {
      id:this.eventId,
      type:this.eventForm.value.eventType,
      title:this.eventForm.value.eventTitle
    }
    this.ngxSpinnerService.show();
    this.cbservice.updateCampaignEvent(this.eventForm.value.company,payload).subscribe({
      next:(res:any)=>{
        this.ngxSpinnerService.hide();
        this.toastrService.success('Campaign event updated successfully');
      },
      error:(error:any)=>{
        this.ngxSpinnerService.hide();
        this.toastrService.success('something went wrong')
      }
    })
  }
}
